import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

export interface WithdrawRequestItem {
  id: number;
  amount: number;
  note: string;
  status: string;
  bankName: string;
  bankAccount: string;
  accountName: string;
  createDate: string;
  createUser: string;
  lastUpdDate: string;
  lastUpdUser: string;
}

export interface CreateWithdrawRequestPayload {
  amount: number;
  note?: string;
  bankName: string;
  bankAccount: string;
  accountName: string;
  passwordBank?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WithdrawRequestService {
  constructor(private api: ApiService) {}

  createWithdrawRequest(payload: CreateWithdrawRequestPayload): Observable<any> {
    const formData = new FormData();
    formData.append('amount', String(Number(payload.amount || 0)));
    formData.append('note', String(payload.note || 'Yêu cầu rút tiền từ ứng dụng'));
    formData.append('status', 'pending');
    formData.append('bankName', String(payload.bankName || ''));
    formData.append('bankAccount', String(payload.bankAccount || ''));
    formData.append('accountName', String(payload.accountName || ''));
    formData.append('passwordBank', String(payload.passwordBank || ''));
    return this.api.postFormData('api/withdraw/request', formData);
  }

  getPendingRequests(): Observable<WithdrawRequestItem[]> {
    return this.api.get<any>('api/withdraw/pending').pipe(
      map((response: any) => {
        const list = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : [];
        return this.normalizeList(list);
      })
    );
  }

  getHistoryRequests(userId: number): Observable<WithdrawRequestItem[]> {
    return this.api.get<any>(`api/withdraw/history/${userId}`).pipe(
      map((response: any) => {
        const list = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : [];
        return this.normalizeList(list);
      })
    );
  }

  approveRequest(id: number): Observable<any> {
    return this.api.post(`api/withdraw/approve/${id}`, {});
  }

  rejectRequest(id: number, reason: string): Observable<any> {
    const encodedReason = encodeURIComponent(String(reason || '').trim());
    return this.api.post(`api/withdraw/reject/${id}?reason=${encodedReason}`, {});
  }

  private normalizeList(raw: any): WithdrawRequestItem[] {
    const list = Array.isArray(raw) ? raw : [];
    return list.map((item: any) => ({
      id: Number(item?.id ?? 0),
      amount: Number(item?.amount ?? 0),
      note: item?.note || '',
      status: String(item?.status || '').toLowerCase(),
      bankName: item?.bankName || '',
      bankAccount: item?.bankAccount || '',
      accountName: item?.accountName || '',
      createDate: item?.createDate || '',
      createUser: item?.createUser || '',
      lastUpdDate: item?.lastUpdDate || '',
      lastUpdUser: item?.lastUpdUser || ''
    }));
  }
}
